<script setup lang="ts">
const props = defineProps<{
    dimension?: Dimension
}>()

/**
 * Translations.
 */
const { t } = useI18n()

/**
 * Use query params.
 */
const { config, options } = useParams()

const show = computed(() => {
    return !(
        props.dimension?.type === 'activity' ||
        props.dimension?.type === 'indicator'
    )
})
</script>

<template>
    <UiSelect
        v-if="show"
        v-model="config.filter"
        :options="options.filters"
        :label="t('filter-by')"
        direction="top"
        class="flex-shrink-0"
        data-tutorial-step="6"
        :data-tutorial-text="t('tutorial-filter')"
    />
</template>